/**
 * 路由 meta 应用器：每页独立 title / description / canonical / JSON-LD。
 * 在浏览器与预渲染（puppeteer 序列化 DOM）两边都生效，
 * 因此预渲染产物 HTML 的 <head> 即包含本页专属 meta。
 */
import { buildJsonLd } from "@/utils/structuredData";

const SITE_ORIGIN = "https://www.panbrain.cn";

function setMetaTag(attrName, attrValue, content) {
  let tag = document.head.querySelector(`meta[${attrName}="${attrValue}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attrName, attrValue);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setCanonical(path) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", SITE_ORIGIN + (path === "/" ? "/" : path));
}

function setJsonLd(routeMeta) {
  // 清掉上一页的 JSON-LD，再按本页 meta 注入
  const olds = document.head.querySelectorAll('script[data-pb-jsonld]');
  olds.forEach((el) => el.parentNode.removeChild(el));
  const kinds = (routeMeta && routeMeta.jsonLd) || [];
  const blocks = buildJsonLd(kinds);
  blocks.forEach((obj) => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-pb-jsonld", "1");
    script.textContent = JSON.stringify(obj);
    document.head.appendChild(script);
  });
}

export function applyRouteMeta(to) {
  const meta = to.meta || {};
  if (meta.title) document.title = meta.title;
  if (meta.description) setMetaTag("name", "description", meta.description);
  setCanonical(to.path);
  setJsonLd(meta);
}

export { SITE_ORIGIN };



// WEBPACK FOOTER //
// ./src/utils/meta.js